import SHDButton from '@ui/Button/SHDButton';
import SHDFooter from '@ui/Footer/SHDFooter';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';
import { Box } from 'grommet';
import { StartPairingProps } from '../scoreSettings.d';

const StartPairing: React.FC<StartPairingProps> = ({
  onTransfer,
  useExistingTeam,
}) => {
  return (
    <>
      <SHDModalContainer>
        <Box direction="column" gap="xsmall" margin={{ bottom: 'xxlarge' }}>
          <SHDHeading level={3} formatCasing={false}>
            How would you like to pair with iScore?
          </SHDHeading>
        </Box>
      </SHDModalContainer>
      <SHDFooter margin={{ top: 'xxlarge' }}>
        <SHDModalContainer gap="small">
          <SHDButton
            primary
            label="Transfer roster to iScore"
            onClick={onTransfer}
          />
          <SHDButton
            secondary
            label="Use existing iScore team"
            onClick={useExistingTeam}
          />
        </SHDModalContainer>
      </SHDFooter>
    </>
  );
};

export default StartPairing;
